import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginBottom: theme.spacing(0.25),
    boxShadow: 'none',
  },

  container: {
    maxHeight: 440,
  },

  searchButton: {
    padding: theme.spacing(2),
  },
}));

export default useStyles;
